import { History, UserPen, Plus, Trash2, Paperclip, PenLine, GraduationCap, FileUp, KeyRound, HardHat, RefreshCw, Mail } from "lucide-react";

const ACTIONS = {
  crear: { label: "Creación", icon: Plus, cls: "bg-emerald-100 text-emerald-800" },
  editar: { label: "Edición", icon: UserPen, cls: "bg-sky-100 text-sky-800" },
  eliminar: { label: "Eliminación", icon: Trash2, cls: "bg-red-100 text-red-800" },
  adjunto: { label: "Adjunto", icon: Paperclip, cls: "bg-indigo-100 text-indigo-800" },
  adjunto_eliminado: { label: "Adjunto eliminado", icon: Trash2, cls: "bg-slate-100 text-slate-700" },
  firma_epi: { label: "Firma EPIs", icon: PenLine, cls: "bg-amber-100 text-amber-800" },
  curso_bloque: { label: "Curso en bloque", icon: GraduationCap, cls: "bg-purple-100 text-purple-800" },
  importar: { label: "Importación", icon: FileUp, cls: "bg-teal-100 text-teal-800" },
  portal: { label: "Portal", icon: KeyRound, cls: "bg-cyan-100 text-cyan-800" },
  entrega_masiva: { label: "Entrega EPIs", icon: HardHat, cls: "bg-orange-100 text-orange-800" },
  revision_epi: { label: "Revisión EPIs", icon: RefreshCw, cls: "bg-lime-100 text-lime-800" },
  usuario: { label: "Usuarios", icon: UserPen, cls: "bg-fuchsia-100 text-fuchsia-800" },
  email: { label: "Email", icon: Mail, cls: "bg-rose-100 text-rose-800" },
};

const fmt = (iso) => new Date(iso).toLocaleString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export default function HistoryList({ entries, showEmployee = false }) {
  if (!entries?.length) {
    return <p className="text-sm text-muted-foreground py-6 text-center flex items-center justify-center gap-2"><History className="h-4 w-4" /> Sin cambios registrados.</p>;
  }
  return (
    <ol className="relative border-l border-slate-200 ml-2 space-y-4" data-testid="history-list">
      {entries.map((h) => {
        const a = ACTIONS[h.action] || { label: h.action, icon: History, cls: "bg-slate-100 text-slate-700" };
        return (
          <li key={h.id} className="ml-5 relative" data-testid={`history-entry-${h.id}`}>
            <span className={`absolute -left-[29px] top-0.5 h-5 w-5 rounded-full flex items-center justify-center ${a.cls}`}>
              <a.icon className="h-3 w-3" />
            </span>
            <div className="flex flex-wrap items-baseline gap-x-2 text-sm">
              <span className={`text-[11px] font-semibold px-1.5 py-0.5 rounded ${a.cls}`}>{a.label}</span>
              {showEmployee && <span className="font-medium">{h.employee_name}</span>}
              <span className="text-muted-foreground text-xs">{fmt(h.at)} · {h.user_name || h.user_email}</span>
            </div>
            {h.detail && <p className="text-xs mt-1 text-slate-700">{h.detail}</p>}
            {h.changes?.length > 0 && (
              <ul className="mt-1 text-xs space-y-0.5">
                {h.changes.slice(0, 8).map((c, i) => (
                  <li key={i} className="text-slate-700">
                    <span className="font-medium">{c.field}:</span> <span className="line-through text-slate-400">{c.before}</span> → {c.after}
                  </li>
                ))}
                {h.changes.length > 8 && <li className="text-muted-foreground">… y {h.changes.length - 8} cambios más</li>}
              </ul>
            )}
            {h.action === "editar" && !h.changes?.length && <p className="text-xs text-muted-foreground mt-1">Guardado sin cambios.</p>}
          </li>
        );
      })}
    </ol>
  );
}
